import { Badge } from "@/components/badge";

interface InfoRowAssignedTeamsProps {
  label: string;
  teams: string[] | undefined;
}

export function InfoRowAssignedTeams({
  label,
  teams,
}: InfoRowAssignedTeamsProps) {
  return (
    <div className="flex justify-between items-start py-2">
      <span className="text-sm font-medium text-gray-500 min-w-0 flex-shrink-0 mr-4">
        {label}
      </span>
      <div className="flex flex-wrap justify-end">
        {teams?.length ? (
          teams.map((team: string) => (
            <Badge className="mr-1 mt-1" isRounded key={team} variant="brand">
              {team}
            </Badge>
          ))
        ) : (
          <span className="text-sm text-text-primary text-right min-w-0 flex-1 font-medium">
            --
          </span>
        )}
      </div>
    </div>
  );
}
